import React from "react";
import styled, { keyframes } from "styled-components";

// 애니메이션 정의
const arrowMovement = keyframes`
  0% { opacity: 0; top: 45%; }
  70% { opacity: 1; }
  100% { opacity: 0; }
`;

// 화살표 컴포넌트 스타일
const Arrow = styled.div`
  opacity: 0;
  position: absolute;
  left: 50%;
  top: 50%;
  transform-origin: center;
  transform: translate3d(-50%, -50%, 0);

  &:before,
  &:after {
    background: ${(props) => props.color || "#000"};
    content: "";
    display: block;
    height: 3px;
    position: absolute;
    top: 0;
    left: 0;
    width: 30px;
  }

  &:before {
    transform: rotate(45deg) translateX(-23%);
    transform-origin: top left;
  }

  &:after {
    transform: rotate(-45deg) translateX(23%);
    transform-origin: top right;
  }

  @media (max-width: 768px) {
    &:before,
    &:after {
      height: 2px;
      width: 20px;
    }
  }
`;

// 첫 번째 화살표
const ArrowFirst = styled(Arrow)`
  animation: ${arrowMovement} 2s ease-in-out infinite;
`;

// 두 번째 화살표
const ArrowSecond = styled(Arrow)`
  animation: ${arrowMovement} 2s 1s ease-in-out infinite;
`;

// 화살표 컨테이너
const ArrowContainer = styled.div`
  background: #222;
  position: absolute;
  left: 49%;
  height: 80vh;
  z-index: 0;

  @media (max-width: 768px) {
    left: 46%;
    height: 60vh;
  }
`;

const ArrowsAnimation = (props) => {
  return (
    <ArrowContainer id="arrow">
      <ArrowFirst color={props.color} className="arrow arrow-first" />
      <ArrowSecond color={props.color} className="arrow arrow-second" />
    </ArrowContainer>
  );
};

export default ArrowsAnimation;
